import {loadAppointmentReasons} from "@services/monolith/appointmentReasons";
import {useEffect, useState} from "react";
import {RootStateApptReason} from "../store/types";
import {appointmentReasonFilterer} from "../utils/filterAppointmentReasons";

export const useLoadApptReasons = (letNullSortIndex: boolean = false): RootStateApptReason[] => {
  const [state, setState] = useState<RootStateApptReason[]>([]);

  useEffect(() => {
    loadAppointmentReasons().then(appointmentReasonFilterer(letNullSortIndex)).then(setState);
  }, [letNullSortIndex]);

  return state;
};
